var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldStopCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.969 12c0 5.52 4.48 10 10 10s10-4.48 10-10-4.47-10-10-10c-5.52 0-10 4.48-10 10zm11.26 4.23h-2.46c-1.66 0-3-1.34-3-3v-2.46c0-1.66 1.34-3 3-3h2.46c1.66 0 3 1.34 3 3v2.46c0 1.66-1.34 3-3 3z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldStopCircle);
export default __webpack_public_path__ + "static/media/vuesax-bold-stop-circle.208b0900060e6740b1cff46fdda6459e.svg";
export { ForwardRef as ReactComponent };